import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { Legend, ReportHeading, LoaderWrapper, ReportOuterWrapper, MuiButton, MuiImage } from '../../../../components'
import ReportsService from '../../../../services/reports.service'
import { useUpdateLhs, useReactQuery } from '../../../../hooks'
import LandscapeCell from './landScapeCell'
import LandScapeHeader from './landScapeHeader'
import { exportExcel_addPercentage, getObjectAsArray, sortByKey } from '../../../../util'
import {
  LegendWrap,
  RootWrap,
  StyledCellWrap,
  TableWrap,
  ListHeaderWrapper,
  ListDetailsWrapper,
  RowTitleHeading,
  RowHeadingContent,
  RowHeadingWrapper,
  ProgressBarWrapper,
  ProgressBar,
  ArrowIconWrapper,
  SliderWrapper,
  IconUpWrap,
  ToolTipContainer,
  TooltipColName,
  TooltipRowName,
  CellContainer,
  StyledTypography,
} from './style'
import { Typography } from '@mui/material'
import { IconArrowDown, IconArrowUpBig, IconGreenArrowV2, IconMixedV2, IconNegativeV2, IconPositiveV2, IconRedArrowV2, Standout, StandoutV2 } from '../../../../assets/images/icons'
import Slider from 'react-slick'
import { IS_SCREEN_BELOW_1366, LEGEND_TEXT_COLOR_MAP, MAGNET_SCORE_IMAGE } from '../../../../constants'
import { useGlobalStore } from '../../../../store'

const ReportLandScape = (props) => {
  const [state, setState] = useState([])
  const [magnetScore, setMagnetScore] = useState([])
  const [showScore, setShowScore] = useState(false)
  const [isDataAvaiableInMatrix, setDataAvaiableInMatrix] = useState(true)
  const [reportExcelData, setReportExcelData] = useState()
  const { updateSubLhsApiLoaded } = useUpdateLhs()
  const headerSliderRef = useRef();
  const listSliderRefs = useRef([]);
  const [showSlider , setShowSlider] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(0)
  const [allExpanded , setAllExpanded] = useState(false);
  // Expand Collapse Copy of state so that state does not render again and again.
  const [expandedRows, setExpandedRows] = useState([]);
  const [isTooltipVisible, setIsTooltipVisible] = useState(false);
  const [tooltipPosition, setTooltipPosition] = useState({ x: 0, y: 0 , width : 0});
  const tooltipRef = useRef();
  const [tooltipContainerHeight, setTooltipContainerHeight] = useState(0);
  const [pptData , setPptData] = useState();
  const [tooltipData, setTooltipData] = useState({
    column: null,
    rowName: '',
    colName: '',
    titleBackgroundColor: 'transparent'
  });
  const initialLegends = props.InsightsElementType === 'CompetitiveLandscapeBrandImagery'
    ? [
      { label: 'Driver Level', value: 'driverLevel' },
      { label: 'Attribute/SubAttribute Level', value: 'attributeLevel' },
      { label: 'Outperform', value: 'Positive' },
      { label: 'Underperform', value: 'Negative' },
    ]
    : [
      { label: 'Positive', value: 'Positive' },
      { label: 'Neutral', value: 'Neutral' },
      { label: 'Mixed', value: 'Mixed' },
      { label: 'Negative', value: 'Negative' },
    ];

  const [legends, setLegends] = useState(initialLegends);

  const { isFullScreen, resizeWidth } = useGlobalStore();

  const useReactQueryObject1 = {
    payloadDetails: {
      queryId: [props.InsightsElementType, props.InsightsElementId, 'data'],
      urlFunc: ReportsService.getCompetitiveLandscapeElement,
      payload: { insightsElementId: props.InsightsElementId },
    },
  }
  const {
    data: data1,
    isLoading: isLoading1,
    isSuccess: isSuccess1,
    isError: isError1,
    error: error1,
  } = useReactQuery(useReactQueryObject1)

  const useReactQueryObject2 = {
    payloadDetails: {
      queryId: [props.InsightsElementType, props.InsightsElementId, 'brandCategoryMetrics'],
      urlFunc: ReportsService.getBrandCategoryMetricsElement,
      payload: { insightsElementId: props.InsightsElementId },
    },
  }
  const {
    data: data2,
    isLoading: isLoading2,
    isSuccess: isSuccess2,
    isError: isError2,
    error: error2,
  } = useReactQuery(useReactQueryObject2)

  const getCustomData = (arr) => {
    const obj = {}

    for (let index = 0; index < arr.length; index++) {
      const element = arr[index]

      if (obj[element.Entity.EntityName]) {
        obj[element.Entity.EntityName] = [...obj[element.Entity.EntityName], element]
      } else {
        obj[element.Entity.EntityName] = [element]
      }
    }
    return obj
  }

  const defaultCarouselSettings = {
    dots: false,
    infinite: false,
    slidesToShow: 6.7,
    slidesToScroll: 1,
    vertical: false,
    verticalSwiping: false,
    swipeToSlide: false,
    draggable: false, 
    touchMove: false, 
    arrows: false,
    initialSlide: currentSlide,
    accessibility : false,
    speed: 0,
    afterChange: (newIndex) => {
      setCurrentSlide(newIndex); 
    }
  }

  const handleSliderChange = useCallback((slideIndex) => {
    setCurrentSlide(slideIndex);

    // Sync all list sliders with the header slider
    listSliderRefs.current.forEach((sliderRef) => {
      if (sliderRef && sliderRef.slickGoTo) {
        sliderRef.slickGoTo(slideIndex);
      }
    });
  }, []);

  const setListSliderRef = useCallback((index) => (ref) => {
    if (ref) {
      listSliderRefs.current[index] = ref;
    }
  }, []);

  useEffect(() => {
    if (state?.length && !isDataAvaiableInMatrix) {
      let obj = {}
      const mappedData = state?.forEach((element) => {
        obj = {
          ...obj,
          ...(element?.customData || {}),
        }
      })
      const data = Object.keys(obj)?.map((key) => {
        const element = obj[key]?.[0] || {}
        return {
          name: element?.Entity?.EntityName,
          logo: element?.Entity?.EntityLogo,
          type: element?.Entity?.EntityType,
        }
      })
      const filteredData = data?.filter((item) => item?.name)

      setMagnetScore(filteredData)
      setPptData((prev) => ({ ...prev, heading: filteredData }))
      setShowScore(false)
      filteredData.length > 7 ? setShowSlider(true) : setShowSlider(false);
    }
  }, [state, isDataAvaiableInMatrix])

  useEffect(() => {
    if (state?.length) {
      const stateArray1 = state
        ?.map((row) =>
          row.EntityImagerySentimentInsight.EntityImagerySentimentInsight.map(
            (d) => d.InsightStandout
          )
        )
        .flat(1)
        ?.filter((flag) => flag)
      if (stateArray1.length > 0) {
        setLegends([{ label: 'Standout Insight', value: 'StandoutInsightV2' }, ...legends])
      }
    }
  }, [state])

  const sorting = (data) => {
    let headingData = []
    let contentData = []

    for (let i = 0; i < data.length; i++) {
      if (data[i]?.InsightSentiment?.length > 0) {
        data[i].eq = 2
        // const arr = [data[i].InsightSentiment, data[i].ImageryIndexSentiment]
        if (data[i].InsightSentiment === 'Positive') {
          data[i].eq = 3
        } else if (data[i].InsightSentiment === 'Negative') {
          data[i].eq = 1
        } else if (data[i].InsightSentiment === 'Neutral') {
          data[i].eq = 4
        }
        contentData.push(data[i])
      } else {
        headingData.push(data[i])
      }
    }

    if (headingData?.length > 0) {
      return headingData
    } else {
      contentData = contentData.slice().sort(function (firstUser, secondUser) {
        if (firstUser.eq < secondUser.eq) return 1
        if (firstUser.eq > secondUser.eq) return -1
        return 0
      })
      return contentData
    }
  }

  const colors = {
    Positive: 'rgba(33, 185, 121, 1)',
    Neutral: '#F5BD4F',
    Negative: 'rgba(238, 37, 52, 1)',
    Mixed: 'rgba(99, 107, 115, 1)',
  }

  // Tooltip handlers
  const handleCellMouseEnter = (column, rowName, colName, element, isLastColumn = false , isFirstColumn = false) => {
    if (element) {
      const rect = element.getBoundingClientRect();
      const isTwoColumn = column?.length > 8;
      let xPosition = rect.left + rect.width / 2;

      if (isTwoColumn) {
        if (isLastColumn) {
          xPosition = rect.left - (rect.width / 2) + 150; 
        } else if (isFirstColumn) {
          xPosition = rect.left - (rect.width / 2) + 330; 
        }
      }

      setTooltipPosition({
        x: xPosition,
        y: rect.top - 10,
        width : rect.width - 10
      });
    }
    
    const getSentiment = (type) =>
      column?.find((item) => item.ImageryIndexSentiment === type)

    const negative = getSentiment('Negative')
    const positive = getSentiment('Positive')
    const neutral = getSentiment('Neutral')
    const mixed = getSentiment('Mixed')
    let titleBackgroundColor = 'transparent';

    if (negative && !positive && !neutral && !mixed) {
      titleBackgroundColor = 'rgba(252, 211, 214, 1)'
    } else if (positive && !negative && !neutral && !mixed) {
      titleBackgroundColor = 'rgba(211, 241, 228, 1)'
    }
    

    setTooltipData({ column, rowName, colName, titleBackgroundColor });
    setIsTooltipVisible(true);

    setTimeout(() => {
      setTooltipContainerHeight(tooltipRef.current?.offsetHeight);
    });

  };

  const handleCellMouseLeave = () => {
    setIsTooltipVisible(false);
    setTooltipData({ column: null, rowName: '', colName: '', titleBackgroundColor: 'transparent'});
    };

  const onSuccessFunc1 = (resp) => {
    const sortingData = (data) => {
      // return data;
      return data.sort(function (a, b) {
        if (a.EntityName < b.EntityName) {
          return -1
        }
        if (a.EntityName > b.EntityName) {
          return 1
        }
        return 0
      })
    }

    const orderedData = resp // sortByKey(resp, 'InsightsElementOrder')
    const uniqueById = Array.from(new Set(orderedData.map((item) => item.DriverName))).map(
      (DriverName) => orderedData.find((item) => item.DriverName === DriverName)
    )

    const data = uniqueById.map((item) => {
      // const data = resp.map((item) => {
      return {
        ...item,
        customData: {
          // Start: [
          //   {
          //     InsightName: item.DriverName,
          //   },
          //   {
          //     InsightName: `(${item.DriverPercent}%)`,
          //   },
          // ],
          ...getCustomData(
            getObjectAsArray(item?.EntityImagerySentimentInsight?.EntityImagerySentimentInsight) ||
              []
          ),
        },
        expanded : false,
        EntityImagerySentimentInsight: {
          EntityImagerySentimentInsight: sortingData(
            getObjectAsArray(item.EntityImagerySentimentInsight.EntityImagerySentimentInsight).map(
              (d) => ({ ...d, EntityType: d.Entity.EntityType, EntityName: d.Entity.EntityName })
            )
          ),
        },
      }
    })

    setState(data)
    setExpandedRows(data)
    updateSubLhsApiLoaded(props)

    setPptData({
      heading : magnetScore,
      content : data
    })

    // Export to Excel code starts here ..
    const reportExcelDataObj = {
      heading: [{ title: 'Driver Names' }, { title: 'Percent' }],
      values: [],
    }
    const reportExcelDataObjHeadingIndex = []
    for (
      let i = 0;
      i < resp[0].EntityImagerySentimentInsight.EntityImagerySentimentInsight.length;
      i++
    ) {
      const val =
        resp[0].EntityImagerySentimentInsight.EntityImagerySentimentInsight[i].Entity.EntityName
      if (reportExcelDataObjHeadingIndex.indexOf(val) === -1) {
        reportExcelDataObj.heading.push({ title: val })
        reportExcelDataObjHeadingIndex.push(val)
      }
    }

    for (let i = 0; i < resp.length; i++) {
      const arr = [{ value: resp[i].DriverName }, exportExcel_addPercentage(resp[i].DriverPercent)]
      const tempValArray = [[], []]
      for (let j = 0; j < reportExcelDataObjHeadingIndex.length; j++) {
        arr.push({ value: '' })
        tempValArray.push([])
      }

      const sentiments = {
        Positive: 1,
        Mixed: 2,
        Neutral: 2,
        Negative: 3,
      }

      for (
        let j = 0;
        j < resp[i].EntityImagerySentimentInsight.EntityImagerySentimentInsight.length;
        j++
      ) {
        const entityObj = resp[i].EntityImagerySentimentInsight.EntityImagerySentimentInsight[j]
        const getIndex = reportExcelDataObjHeadingIndex.indexOf(entityObj.Entity.EntityName) + 2
        let sign = ''
        if (entityObj.InsightSentiment === 'Negative') {
          sign = '-'
        } else if (entityObj.InsightSentiment === 'Positive') {
          sign = '+'
        } else if (entityObj.InsightSentiment === 'Neutral' || entityObj.InsightSentiment === 'Mixed') {
          sign = '~'
        }
        let value = (sign + entityObj.InsightName)
          .replace('++', '+')
          .replace('--', '-')
          .replace('~~', '~')
        if (value === '~' || value === '+' || value === '-') value = ''

        const sentimentPriority = sentiments[entityObj.InsightSentiment] || 2;

        tempValArray[getIndex].push({ value, sentimentPriority });
      }

      for (let idx = 2; idx < tempValArray.length; idx++) {
        const sorted = tempValArray[idx]
          .sort((a, b) => a.sentimentPriority - b.sentimentPriority)
          .map((item) => item.value);

        arr[idx] = { value: sorted.join(', ') };
      }

      reportExcelDataObj.values.push(arr)
    }
    setReportExcelData(reportExcelDataObj)
  }

  const onSuccessFunc2 = (resp) => {
    setDataAvaiableInMatrix(!!resp?.length)
    const filteredData = resp
      .filter((item) => item.Entity.EntityType !== 'Category')
      .filter((item) => item.Entity.EntityType !== 'HiddenBrand')
    const modifiedData = filteredData.map((item) => ({
      name: item.Entity.EntityName,
      logo: item.Entity.EntityLogo,
      score: item.BrandMagnetScore,
      type: item.Entity.EntityType,
    }))
    const isScoreFound = modifiedData?.every((item) => item?.score)
    // const multipliedData = [...modifiedData, ...modifiedData]
    // const multipliedData = modifiedData
    setShowScore(isScoreFound && resp.length)
    setMagnetScore(modifiedData)
    setPptData((prev) => ({ ...prev, heading: modifiedData }))
    updateSubLhsApiLoaded(props)
    modifiedData.length > 7 ? setShowSlider(true) : setShowSlider(false);
  }

  useEffect(() => {
    if (isSuccess1 && data1.length) onSuccessFunc1(data1)
    if (isSuccess2 && data2) onSuccessFunc2(data2)
  }, [isSuccess1, data1, isSuccess2, data2])

  const handleChangeArrow = (index) => {
    setExpandedRows(prev =>
      prev.map((item, i) =>
        i === index ? { ...item, expanded: !item.expanded } : item
      )
    );
  };

  const ExpandCollapseAll = () => {
    setAllExpanded(prev => !prev);

    setExpandedRows(prev =>
      prev.map(item => ({
        ...item,
        expanded: !allExpanded
      }))
    );
  };

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'ArrowRight') {
        const nextSlide = currentSlide + 1;
        slideTo(nextSlide);
      } else if (e.key === 'ArrowLeft') {
        const prevSlide = currentSlide - 1;
        slideTo(prevSlide);
      }
    };

    const slideTo = (index) => {
      if (!headerSliderRef.current) return;

      const totalSlides = headerSliderRef.current.props.children.length;
      const clampedIndex = Math.max(0, Math.min(index, totalSlides - 1));

      setCurrentSlide(clampedIndex);
      headerSliderRef.current.slickGoTo(clampedIndex);

      listSliderRefs.current.forEach((ref) => {
        if (ref?.slickGoTo) {
          ref.slickGoTo(clampedIndex);
        }
      });
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [currentSlide]);

  // Calculate width using useMemo
  const slideWrapperWidth = useMemo(() => {
    if (resizeWidth < 1350) return 'calc(100vw - 150px)';
    // if (resizeWidth < 1350) return 'calc(100vw - 89px)';
    if (isFullScreen) return 'calc(100vw - 110px)';
    return 'calc(100vw - 315px)';
  }, [resizeWidth, isFullScreen]);

  return (
    <>
      {!!state?.length && !!magnetScore?.length && (
        <>
          <ReportHeading 
          downloadId={props.type} 
          {...props} 
          pptData={pptData}
          downloadIdData={reportExcelData} 
          additionalButton={<AdditionalButtons isExpendedAll={allExpanded} expandCollapseFunc={ExpandCollapseAll} showScore={showScore} />} 
          />
          <ReportOuterWrapper type={props.InsightsElementType}>
            <LoaderWrapper
              loadOnlyApi={props.loadOnlyApi}
              isLoading={isLoading1}
              isSuccess={isSuccess1}
              isError={isError1}
              error={error1}
            >
              {/* <LoaderWrapper isLoading={isLoading2} isSuccess={isSuccess2} isError={isError2} error={error2}> */}
              <RootWrap
                id={props.type}
                dataLength={state?.length}
                className={`sticky${props.InsightsElementType}`}
              >
                {/* Tooltip positioned absolutely */}
                {isTooltipVisible && (
                  <ToolTipContainer
                    ref={tooltipRef}
                    style={{
                      position: 'fixed',
                      left: tooltipPosition.x,
                      top: `${tooltipPosition.y + tooltipContainerHeight + 40}px`,
                      transform: 'translate(-50%, -100%)',
                      zIndex: 7,
                      pointerEvents: 'none',
                      width: `${tooltipData.column?.length > 8 ? tooltipPosition.width * 2 + 10 : tooltipPosition.width}px`,
                      paddingBottom : `${tooltipData.column ? 12 : 0}px`
                    }}
                  >
                    <TooltipColName>{tooltipData.colName}</TooltipColName>
                    <TooltipRowName titleBackgroundColor={tooltipData.titleBackgroundColor}>{tooltipData.rowName}</TooltipRowName>
                    {tooltipData.column?.length > 0 && <CellContainer
                     direction={tooltipData.column?.length > 8 ? 'row' : 'column'} >
                      {/* Left Column - First 8 */}
                      <div style={{ flex: tooltipData.column?.length > 7 ? 1 : 'unset' }}>
                        {sorting(tooltipData?.column)?.slice(0, 8).map((item, index) => {
                          return (
                            <StyledTypography
                              key={item.InsightName + index}
                              className="textItemShadow toolTipItem"
                              fontcolor={
                                item.InsightSentiment === 'Mixed'
                                  ? LEGEND_TEXT_COLOR_MAP.Mixed
                                  : colors[item.InsightSentiment]
                              }
                            >
                              {(item.InsightSentiment === 'Mixed' && <IconMixedV2 />) ||
                                (item.InsightSentiment === 'Negative' && <IconNegativeV2 />) ||
                                (item.InsightSentiment === 'Positive' && <IconPositiveV2 />)}

                              <label>{item.InsightName || ''}</label>

                              {item.InsightSentiment && item.InsightName && item?.InsightStandoutType === 'New' && (
                                <span><StandoutV2 /></span>
                              )}
                              {item.InsightSentiment && item.InsightName && item?.InsightStandoutType === 'Up' && (
                                <span><IconGreenArrowV2 /></span>
                              )}
                              {item.InsightSentiment && item.InsightName && item?.InsightStandoutType === 'Down' && (
                                <span><IconRedArrowV2 /></span>
                              )}
                            </StyledTypography>
                          );
                        })}
                      </div>

                      {/* Right Column - Rest */}
                      {tooltipData.column?.length > 7 && <div style={{ flex: 1 }}>
                        {sorting(tooltipData?.column)?.slice(8).map((item, index) => {
                          return (
                            <StyledTypography
                              key={item.InsightName + (index + 8)}
                              className="textItemShadow toolTipItem"
                              fontcolor={
                                item.InsightSentiment === 'Mixed'
                                  ? LEGEND_TEXT_COLOR_MAP.Mixed
                                  : colors[item.InsightSentiment]
                              }
                            >
                              {(item.InsightSentiment === 'Mixed' && <IconMixedV2 />) ||
                                (item.InsightSentiment === 'Negative' && <IconNegativeV2 />) ||
                                (item.InsightSentiment === 'Positive' && <IconPositiveV2 />)}

                              <label>{item.InsightName || ''}</label>

                              {item.InsightSentiment && item.InsightName && item?.InsightStandoutType === 'New' && (
                                <span><StandoutV2 /></span>
                              )}
                              {item.InsightSentiment && item.InsightName && item?.InsightStandoutType === 'Up' && (
                                <span><IconGreenArrowV2 /></span>
                              )}
                              {item.InsightSentiment && item.InsightName && item?.InsightStandoutType === 'Down' && (
                                <span><IconRedArrowV2 /></span>
                              )}
                            </StyledTypography>
                          );
                        })}
                      </div>}
                    </CellContainer>
                    }

                  </ToolTipContainer>
                )}
                <TableWrap className={`listWrapper ${showSlider ? 'slider-Wrapper' : ''}`}>
                  <ListHeaderWrapper className={`pptListWrapper pptListHeader ${showSlider ? 'sliderOn' : 'sliderOff'}`}>
                    <LandScapeHeader 
                    slideWrapperWidth={slideWrapperWidth}
                    ref={headerSliderRef}
                    onSliderChange={handleSliderChange}
                    currentSlide={currentSlide} 
                    showScore={showScore}
                    showSlider={showSlider}
                    scores={[...magnetScore]} />
                  </ListHeaderWrapper>
                  {state?.map((row, i) => {
                    return (
                      <ListDetailsWrapper key={i} className={`pptListWrapper ${showSlider ? ' sliderOn' : 'sliderOff'} ${expandedRows[i].expanded ? '' : 'row-collapsed'}`}>
                        <RowHeadingWrapper onClick={() => handleChangeArrow(i)}>
                        <div className='row-head'>
                          <RowTitleHeading className={`${i === 0 ? 'row-head-wrap' : ''}`}>
                            <Typography>{row.DriverName}</Typography>
                            <Typography className='row-percentage'>{row.DriverPercent}%</Typography>
                          </RowTitleHeading>
                          {/* Row Bluebar according to percentage */}
                          {/* <ProgressBarWrapper>
                            <ProgressBar width={row.DriverPercent} />
                          </ProgressBarWrapper> */}
                        </div>
                          <ArrowIconWrapper className='row-arrow-icons'>
                            {expandedRows[i].expanded ? <IconUpWrap><IconArrowUpBig /></IconUpWrap> : <IconArrowDown />}
                          </ArrowIconWrapper>
                        </RowHeadingWrapper>
                        <RowHeadingContent className='content-wrapper'>
                          {!showSlider ?
                            magnetScore.map(
                              (columnKey, index, arr) => {
                                const column = row?.customData?.[columnKey.name]
                                return (
                                  <StyledCellWrap
                                    className={`list ${expandedRows[i].expanded ? '' : 'list-collapsed'}`}
                                    key={columnKey?.name}
                                    width={`${100 / arr.length}%`}
                                    
                                  >
                                    <LandscapeCell
                                      legends={legends.filter((f) => f.value === 'StandoutInsight')}
                                      column={column}
                                      isLastColumn={index + 1 === arr.length}
                                      isFirstColumn={index === 0}
                                      expandView={expandedRows[i].expanded}
                                      rowName={row.DriverName}
                                      colName={columnKey.name}
                                      onMouseEnter={handleCellMouseEnter}
                                      onMouseLeave={handleCellMouseLeave}
                                      sorting={sorting}
                                      colors={colors}
                                    />
                                  </StyledCellWrap>
                                )
                              }
                            )
                            : <SliderWrapper key={resizeWidth} slideWrapperWidth={slideWrapperWidth} mdScreen={IS_SCREEN_BELOW_1366()} isFullScreen={isFullScreen}>
                              <Slider ref={setListSliderRef(i)}  {...defaultCarouselSettings}>
                                {magnetScore.map(
                                  (columnKey, index, arr) => {
                                    const column = row?.customData?.[columnKey.name]
                                    return (
                                      <StyledCellWrap
                                        className={`list ${expandedRows[i].expanded ? '' : 'list-collapsed'}`}
                                        key={columnKey?.name}
                                        width={`${100 / arr.length}%`}
                                      >
                                        <LandscapeCell
                                          legends={legends.filter((f) => f.value === 'StandoutInsight')}
                                          column={column}
                                          isLastColumn={index + 1 === arr.length}
                                          isFirstColumn={index === 0}
                                          expandView={expandedRows[i].expanded}
                                          rowName={row.DriverName}
                                          colName={columnKey.name}
                                          onMouseEnter={handleCellMouseEnter}
                                          onMouseLeave={handleCellMouseLeave}
                                          sorting={sorting}
                                          colors={colors}
                                        />
                                      </StyledCellWrap>
                                    )
                                  }
                                )}
                              </Slider>
                            </SliderWrapper>
                          }
                        </RowHeadingContent>
                       
                 
                      </ListDetailsWrapper>
                    )
                  })}
                </TableWrap>
                <LegendWrap>
                  <Legend legends={legends} />
                </LegendWrap>
              </RootWrap>
              {/* </LoaderWrapper> */}
            </LoaderWrapper>
          </ReportOuterWrapper>
        </>
      )}
    </>
  )
}

const AdditionalButtons = ({ isExpendedAll, expandCollapseFunc , showScore }) => {
  return (
    <>
      {showScore && 
      <Typography fontSize={'14px'} display={'flex'} alignItems={'center'} gap={'4px'}>
        <MuiImage src={MAGNET_SCORE_IMAGE['Start'].icon} width='15px' height='15px' />
        Magnet Score
      </Typography>
      }
      <MuiButton
        variant='outlined'
        color='light'
        startIcon={isExpendedAll ? <IconArrowUpBig /> : <IconArrowDown />}
        onClick={() => expandCollapseFunc(!isExpendedAll)}
      >
        {isExpendedAll ? 'Collapse All' : 'Expand All'}
      </MuiButton>
      </>
  )
}



export default ReportLandScape
